import { DocumentData } from "firebase/firestore";
import { GridElement } from "../../../types/gridElement";
import { beforeWrapper, borderSettings } from "../../../utils";
import { ShowTableData } from "../../ShowTableData";

export const NonOperatingExpenses = ({
  headers,
  state,
  descriptions,
  url,
  unit,
}: {
  headers: DocumentData[];
  state: DocumentData;
  descriptions: DocumentData;
  url: string;
  unit: number;
}) => {
  const grid: GridElement[][] = [];

  // className
  const classCol1 = `${beforeWrapper} p-4px left-0 text-14px font-bold bg-white before:border-x before:border-r-c3333334d before:border-b`;

  const classCol2 = `${borderSettings} p-4px before:border-l before:border-l-c3333334d
        before:border-b text-14px  text-right`;

  const classCol3 = `${borderSettings} p-4px before:border-x before:border-l-c3333334d
        before:border-b text-14px h-50px description`;

  const gridRow: GridElement[] = [
    {
      value: "③営業外費用",
      readOnly: true,
      className: `${classCol1}`,
    },
  ];

  headers?.map((header: DocumentData, tdIndex: number) => {
    if (tdIndex === 0) return;

    gridRow.push({
      value: ShowTableData(state[tdIndex] / unit),
      expr: state[tdIndex] / unit,
      readOnly: true,
      className: `${classCol2}`,
    });
  });

  gridRow.push({
    value: descriptions[`${url}_non_operating_expenses`],
    readOnly: false,
    className: `${classCol3}`,
    field: `${url}_non_operating_expenses`,
    key: "descriptions_calc",
    row: descriptions,
  });
  grid.push(gridRow);

  return grid;
};
